export const marquee = () => {
  const init = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      // Clean up clones if resized down to mobile
      document.querySelectorAll('.intro__marquee-inner, .common__marquee-inner').forEach(inner => {
        const allSpans = inner.querySelectorAll('span');
        for (let i = 1; i < allSpans.length; i++) {
          allSpans[i].remove();
        }
        inner.style.removeProperty('--translate-x');
      });
      return;
    }

    const marqueeInners = document.querySelectorAll('.intro__marquee-inner, .common__marquee-inner');
    marqueeInners.forEach(inner => {
      const originalSpan = inner.querySelector('span');
      if (!originalSpan) return;

      const spanWidth = originalSpan.getBoundingClientRect().width;
      if (!spanWidth) return;

      const screenWidth = window.innerWidth;
      
      // Clear any previously cloned spans (keep only the first span)
      const allSpans = inner.querySelectorAll('span');
      for (let i = 1; i < allSpans.length; i++) {
        allSpans[i].remove();
      }

      // Calculate how many spans we need to fill the screen width + safety buffer (at least 4 spans)
      const neededCount = Math.max(4, Math.ceil(screenWidth / spanWidth) + 2);

      // Clone the original span to meet the count
      for (let i = 1; i < neededCount; i++) {
        const clone = originalSpan.cloneNode(true);
        inner.appendChild(clone);
      }

      // Set the translation pixel value as a CSS variable on the inner container
      // Using exact pixel width of 1 span ensures a pixel-perfect seamless loop.
      inner.style.setProperty('--translate-x', `-${spanWidth}px`);
    });
  };

  // Run initial calculations
  init();

  // Also run when fonts are fully loaded to ensure correct text width measurements
  if (document.fonts) {
    document.fonts.ready.then(init);
  }

  // Re-calculate on window resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });
};